import { Avatar, AvatarProps } from 'antd';
import { ReactComponent as AvatarUserIcon } from '@Icons/additional/avatar-user.svg';
import classNames from 'classnames';

interface MAvatarProps extends AvatarProps {}

const MAvatar: React.FC<MAvatarProps> = (props) => {
  return (
    <Avatar
      icon={<AvatarUserIcon />}
      {...props}
      className={classNames('trojan-avatar', props.className)}
    />
  );
};

export default MAvatar;
